import api from '../../api.js';
import * as Sentry from '@sentry/browser';
import dataLayer from '../../lib/gtm';

function defaultState() {
    return {
        id: '',
        org_id: '',
        fname: '',
        lname: '',
        email: '',
        phone_numbers: [],
        settings: {},
        pinned_paths: [],
        recent_paths: [],
        is_email_verified: false,
        has_agreed_to_terms: false,
        role: 'user',
    };
}

export default {
    namespaced: true,
    state: defaultState(),
    getters: {
        exists(state) {
            return !!state.id
        },
        user(state, getters) {
            return {
                ...state,
                name: state.fname && state.lname ? `${state.fname} ${state.lname}` : 'New User',
                name_reversed: state.fname && state.lname ? `${state.lname}, ${state.fname}` : 'New User',
                hasRole: getters.hasRole
            };
        },
        settings(state) {
            return state.settings;
        },
        requiresOnboarding(state, getters) {
            return getters.exists && (
                !state.is_email_verified ||
                !state.org_id ||
                !state.fname ||
                !state.lname ||
                !state.has_agreed_to_terms
            );
        },
        hasRole: (state, getters, rootState, rootGetters) => (minimumRole) => {
            if (rootGetters['auth/isSuperAdmin']) return true;
            const userLevel = rootGetters['auth/roles'].findIndex(role => role.value === state.role);
            return userLevel !== -1 && userLevel <= rootGetters['auth/roles'].findIndex(role => role.value === minimumRole);
        }
    },
    mutations: {
        update(state, user) {
            for (let key in user) {
                state[key] = user[key];
            }
        },
        clear(state) {
            let defaults = defaultState();
            for (let key in defaults) {
                state[key] = defaults[key];
            }
            Sentry.configureScope(scope => scope.setUser(null));
        }
    },
    actions: {
        async load({ commit }, params) {
            const user = await api.get('user', params);
            commit('update', user);

            // Set user details in Sentry for ease of error tracking
            Sentry.configureScope(scope => {
                scope.setUser({
                    email: user.email,
                    id: user.id,
                    org_id: user.org_id
                });
            });
        },
        async save({ commit }, data) {
            let res = await api.put('user', data);
            commit('update', data);
            return res.success;
        },
        async onboard({ dispatch, state, rootGetters }, data) {
            const isNewOrg = !state.org_id;
            await api.post('user/onboard', data);
            await dispatch('org/loadInfo', ['users', 'boxes', 'org'], { root: true });
            if (isNewOrg) {
                // Fire new org creation event in GTM
                dataLayer.push({
                    event: 'NewOrganizationCreated',
                    organizationId: rootGetters['org/org'].id,
                    partnerId: rootGetters['base/partner']?.id || null,
                });
            }
            await dispatch('load');
        },
        async updateSettings({ dispatch, state }, settings) {
            for (let key in state.settings) {
                if (!settings.hasOwnProperty(key)) {
                    settings[key] = state.settings[key];
                }
            }
            const data = { settings };
            return await dispatch('save', data);
        }
    }
}